//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getAction, putAction } from '@/api/manage';
import ShowAnnouncement from '@/components/tools/ShowAnnouncement';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
export default {
  name: "UserAnnouncementList",
  mixins: [JeecgListMixin],
  components: {
    ShowAnnouncement: ShowAnnouncement
  },
  data: function data() {
    return {
      description: '系统通告表管理页面',
      queryParam: {},
      peopleTreeData: [],
      columns: [{
        title: '标题',
        align: "center",
        dataIndex: 'titile'
      }, {
        title: '消息类型',
        align: "center",
        dataIndex: 'msgCategory',
        customRender: function customRender(text) {
          if (text == '1') {
            return "通知公告";
          } else if (text == "2") {
            return "系统消息";
          } else {
            return text;
          }
        }
      }, {
        title: '发布人',
        align: "center",
        dataIndex: 'sender'
      }, {
        title: '发布时间',
        align: "center",
        dataIndex: 'sendTime'
      }, {
        title: '优先级',
        align: "center",
        dataIndex: 'priority',
        customRender: function customRender(text) {
          if (text == 'L') {
            return "低";
          } else if (text == "M") {
            return "中";
          } else if (text == "H") {
            return "高";
          } else {
            return text;
          }
        }
      }, {
        title: '阅读状态',
        align: "center",
        dataIndex: 'readFlag',
        customRender: function customRender(text) {
          if (text == '0') {
            return "未读";
          } else if (text == "1") {
            return "已读";
          } else {
            return text;
          }
        }
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: "/system/sysAnnouncementSend/getMyAnnouncementSend",
        editCementSend: "system/sysAnnouncementSend/editByAnntIdAndUserId",
        readAllMsg: "system/sysAnnouncementSend/readAll"
      },
      loading: false
    };
  },
  created: function created() {
    this.loadData();
    this.loadPeopleTree();
  },
  methods: {
    loadPeopleTree: function loadPeopleTree() {
      var that = this;
      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.peopleTreeData = res.result;
        }
      });
    },
    handleDetail: function handleDetail(record) {
      this.$refs.sysAnnouncementModal.detail(record);
      this.$refs.sysAnnouncementModal.title = "查看";
    },
    showAnnouncement: function showAnnouncement(record) {
      var _this = this;

      putAction(this.url.editCementSend, {
        anntId: record.anntId
      }).then(function (res) {
        if (res.success) {
          _this.loadData();
        }
      });
      this.$refs.ShowAnnouncement.detail(record);
    },
    readAll: function readAll() {
      var that = this;
      that.$confirm({
        title: "确认操作",
        content: "是否全部标注已读?",
        onOk: function onOk() {
          putAction(that.url.readAllMsg).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadData();
            }
          });
        }
      });
    }
  }
};